import { css } from '@emotion/react'
import styled from '@emotion/styled'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  /* margin-left: 1rem; */
`;

const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  justify-content: center;
  align-items: center;
`;

const Connector = styled.div`
  margin: .3rem 0;
  border-left: 1px solid ${props => props.color || "#ccc"};
  /* margin-left: .5rem; */
  flex-grow: 1;
`;

const TimelineDot = styled.div`
  width: .8rem;
  height: .8rem;
  border-radius: 50%;
  background-color: ${props => props.color || "#ccc"};
`;

const Content = styled.div`
  /* margin: 1rem 0;
  border-left: 2px solid ${props => props.color || "#ccc"};
  padding: .5rem;
  padding-left: 2rem;
  margin-left: .5rem; */
  padding: 1.5rem 0;
  width: 100%;
`;


const TimelineItem = ({ TimelineColor, last, children }) => {

  return (
    <Container>
      <Timeline>
        <TimelineDot color={TimelineColor} />
        <Connector color={TimelineColor} />
        {last && <TimelineDot color={TimelineColor} /> }
      </Timeline>
      <Content>{children}</Content>
    </Container>
  )
};

export default TimelineItem;